import { HOTMART_LINK_DEFAULT_LABEL, HOTMART_URL } from './constants'

import HotmartGrey from 'common/assets/img/illustration/hotmart_grey.svg'

interface Props {
  label?: string,
  url?: string
}

const PoweredBy = ({
  label = HOTMART_LINK_DEFAULT_LABEL,
  url = HOTMART_URL
}: Props) => {
  const link = (
    <a
      className="link"
      href={url}
      target="_blank"
      rel="noreferrer noopener">
      {label}
    </a>
  )

  return (
    <div className="powered-by" data-test="powered-by">
      <img alt="Hotmart Logo" className="icon" src={HotmartGrey} />
      <span>Powered by {link}</span>
    </div>
  )
}

export default PoweredBy
